import config from '../config';
import { authHeader, customFetch, handleResponse, commonRequestOptions } from '../helpers';

const endpointPath = config.api.API_URL + '/search';

export const searchService = {
  getAll,
  getAllByName,
  getAllByObject,
};

function getAll(search, objectName, n, append, signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(
    `${endpointPath}/all/${search}/${objectName}/${n}/${append}`,
    requestOptions,
    signal,
    true
  ).then(handleResponse);
}

function getAllByName(search, objectName, signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(
    `${endpointPath}/all_by_name/${search}/${objectName}`,
    requestOptions,
    signal,
    true
  ).then(handleResponse);
}

function getAllByObject(objectName, n, append, signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(
    `${endpointPath}/all_by_object/${objectName}/${n}/${append}`,
    requestOptions,
    signal,
    true
  ).then(handleResponse);
}
